"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pintuanApi = _interopRequireWildcard(require("@/api/pintuanApi"));
var _SendPintuan = _interopRequireDefault(require("./SendPintuan.vue"));
var _PintuanCreate = _interopRequireDefault(require("./PintuanCreate.vue"));
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
var _BindImport = _interopRequireDefault(require("./BindImport.vue"));
var _static = require("../static");
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var _SyncProduct = _interopRequireDefault(require("./SyncProduct.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _bindcakeTag = _interopRequireDefault(require("./bindcakeTag.vue"));
var _AsyncExportButton = _interopRequireDefault(require("@/components/AsyncExportButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SendPintuan: _SendPintuan.default,
    PintuanCreate: _PintuanCreate.default,
    ButtonUploadExcel: _ButtonUploadExcel.default,
    BindImport: _BindImport.default,
    SyncProduct: _SyncProduct.default,
    BindcakeTag: _bindcakeTag.default,
    AsyncExportButton: _AsyncExportButton.default
  },
  data: function data() {
    return {
      FROM_TYPE_OPTIONS: _static.FROM_TYPE_OPTIONS,
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      brandOption: []
    };
  },
  computed: {
    cakeExportParams: function cakeExportParams() {
      var params = _objectSpread({}, this.listPram);
      delete params.page;
      delete params.limit;
      return params;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var brandId = this.$route.params.brandId;
    if (brandId) {
      // this.listPram['brandId']=brandId;
      this.searchBrand(brandId, 1);
    } else {
      this.searchBrand('');
      this.handlerGetListData(this.listPram);
    }
  },
  methods: {
    throttle: _throttle.default,
    handerSearch: function handerSearch() {
      var _this$listPram;
      if (!((_this$listPram = this.listPram) !== null && _this$listPram !== void 0 && _this$listPram.brandId)) {
        this.searchBrand('');
      }
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      dangaoActApi.getcakeLists(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    handlerDelete: function handlerDelete(id) {
      var _this2 = this;
      this.$confirm('确定删除当前数据', '提示', {
        type: 'warning'
      }).then(function (result) {
        dangaoActApi.deletecake(id).then(function (data) {
          _this2.$message.success('删除数据成功');
          _this2.handlerGetListData(_this2.listPram);
        });
      });
    },
    // 修改状态
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      var _ref = row || {},
        id = _ref.id,
        skuId = _ref.skuId,
        source = _ref.source,
        status = _ref.status;
      dangaoActApi.changeStatecake({
        id: id,
        skuId: skuId,
        source: source,
        status: status
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.$message.success('修改成功');
              _this3.handlerGetListData();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))).catch(function () {
        _this3.handlerGetListData();
      });
    },
    changeCakePrice: function changeCakePrice(row) {
      var _this4 = this;
      var _ref3 = row || {},
        id = _ref3.id,
        skuId = _ref3.skuId,
        source = _ref3.source,
        defaultPrice = _ref3.defaultPrice;
      dangaoActApi.changeCakePrice({
        id: id,
        skuId: skuId,
        source: source,
        price: defaultPrice
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this4.$message.success('修改成功');
              _this4.handlerGetListData();
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {
        _this4.handlerGetListData();
      });
    },
    editDgGood: function editDgGood(id) {
      this.$router.push({
        path: "/store/dangao/lists/dgEdit/".concat(id || 0)
      });
    },
    bindTag: function bindTag(id) {
      var _this$$refs$BindcakeT;
      (_this$$refs$BindcakeT = this.$refs['BindcakeTagRef']) === null || _this$$refs$BindcakeT === void 0 ? void 0 : _this$$refs$BindcakeT.openInit(id);
    },
    beforeUpload: function beforeUpload(file) {
      var _this5 = this;
      var formData = new FormData();
      formData.append('file', file);
      dangaoActApi.importUpdatePriceCake(formData).then(function (res) {
        _this5.$message.success('导入成功！');
        _this5.handerSearch();
      });
    },
    importEdit: function importEdit() {},
    importSelf: function importSelf() {
      var _this$$refs$BindImpor;
      (_this$$refs$BindImpor = this.$refs['BindImportRef']) === null || _this$$refs$BindImpor === void 0 ? void 0 : _this$$refs$BindImpor.openInit({
        title: '关联自营商品',
        methodName: 'importSelf',
        tips: '文件中需包含：自营商品SPU ID、蛋糕品牌门店ID、展示状态，可选择添加下单须知'
      });
    },
    asyncGoods: function asyncGoods() {
      var _this$$refs$SyncProdu;
      (_this$$refs$SyncProdu = this.$refs['SyncProductRef']) === null || _this$$refs$SyncProdu === void 0 ? void 0 : _this$$refs$SyncProdu.openInit();
    },
    // 品牌查询
    searchBrand: function searchBrand() {
      var _this6 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var isInit = arguments.length > 1 ? arguments[1] : undefined;
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword).then(function (res) {
        _this6.brandOption = res && res.length && res.map(function (item) {
          var _ref5 = item || {},
            brandId = _ref5.brandId,
            brandName = _ref5.brandName,
            source = _ref5.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
        if (isInit) {
          var _this6$brandOption, _this6$brandOption$;
          _this6.listPram['brandId'] = (_this6$brandOption = _this6.brandOption) === null || _this6$brandOption === void 0 ? void 0 : (_this6$brandOption$ = _this6$brandOption[0]) === null || _this6$brandOption$ === void 0 ? void 0 : _this6$brandOption$.id;
          _this6.handlerGetListData(_this6.listPram);
        }
        ;
      });
    },
    // 搜索品牌
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this7 = this;
      this.throttle(function () {
        _this7.searchBrand(data);
      }, 300)();
    }
  }
};